import { atom } from 'jotai'

export type NotificationSeverity = 'success' | 'error' | 'warning' | 'info'

export interface Notification {
  id: string
  message: string
  severity: NotificationSeverity
  autoHideDuration?: number
  action?: {
    label: string
    onClick: () => void
  }
}

// Current notification to display
export const notificationAtom = atom<Notification | null>(null)

// Helper to generate unique IDs
let notificationId = 0
export const generateNotificationId = () => `notification-${++notificationId}`
